import {
    formatDateOfBirth,
    type GetClientProfileOutput,
    toClientTimeZone,
    toUsStateName,
    type UpdateClientProfileInput,
} from '@/entities/client';
import { formatPhone } from '@/shared/lib/format-utils';

// FR-010: prefill from the saved record, empty where nothing is saved — except the two fields
// that carry a default instead (FR-016, FR-036).
export function buildEditClientProfileDefaults(
    profile: GetClientProfileOutput,
): UpdateClientProfileInput {
    return {
        id: profile.id,
        firstName: profile.firstName,
        lastName: profile.lastName,
        middleName: profile.middleName,
        preferredFirstName: profile.preferredFirstName,
        dateOfBirth: formatDateOfBirth(profile.dateOfBirth),
        emailPrimary: profile.emailPrimary ?? '',
        phonePrimary: formatPhone(profile.phonePrimary),
        // FR-016: no saved zone defaults to the therapist's own browser zone, when curated.
        timeZone: toClientTimeZone(profile.timeZone),
        address: {
            street1: profile.address?.street1 ?? '',
            street2: profile.address?.street2 ?? '',
            city: profile.address?.city ?? '',
            state: toUsStateName(profile.address?.state ?? ''),
            zip: profile.address?.zip ?? '',
        },
        okToEmail: profile.okToEmail,
        okToCallText: profile.okToCallText,
        // No control edits these, but the update command still requires them: they stay in the form
        // values so a save sends the stored choice back instead of resetting it.
        // FR-036: both off is the query's own default too — `?? false` just keeps that contract
        // even if a future reader ever slips and returns null.
        emailReminders: profile.emailReminders ?? false,
        textReminders: profile.textReminders ?? false,
        sex: profile.sex,
        // FR-032 reads the empty string as "Other selected, nothing typed" — a stored empty string
        // means no pronoun recorded, so it opens with no choice selected instead of an error.
        pronouns: profile.pronouns || null,
    };
}
